import React from "react";
import moment from "moment";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { serverFormat } from "../../../utils/dates";
import InternalActions from "./InternalActions";
import CardExpandable from "../../card/CardExpandable";
import DetailField from "../../card/DetailField";
import OrderStatusChip from "../orders/OrderStatusChip";
import { movewareJobId } from "src/components/integrations/moveware/movewareJobDisplay";

export default function InternalRowMobile({
  item,
  refetch,
  showBillingCharge = false,
  showMovewareDetails = false,
}) {
  const orderNumber =
    item.revisionNumber > 0
      ? `${item.internalWorkOrderNumber}.R${item.revisionNumber}`
      : item.internalWorkOrderNumber;

  const submittedOn = moment(item.createdAt, serverFormat).format("lll");
  const submittedBy = item.user?.email;
  const billingChargeTotal =
    item.billingCharges?.grand_total ??
    item.billingCharges?.grandTotal ??
    item.internalWorkOrderCharges?.total;

  const formatBillingCharge = total => {
    if (total == null || total === "") return "-";

    return Number(total).toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
    });
  };

  return (
    <Card>
      <CardContent sx={{ "&:last-child": { pb: 2 } }}>
        <Box mb={2}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography color="text.secondary" fontWeight={500}>
              {orderNumber}
            </Typography>
            <Chip
              label={moment(item.createdAt, serverFormat).format("ll")}
              size="small"
              sx={{ borderRadius: 1, backgroundColor: "rgba(0, 0, 0, 0.05)" }}
            />
          </Box>
          <Typography mt={1} color="primary" sx={{ wordBreak: "break-word" }}>
            {submittedBy}
          </Typography>
        </Box>
        <CardExpandable actions={<InternalActions item={item} refetch={refetch} />}>
          <Box display="flex" flexDirection="column" gap={1}>
            <DetailField label="Submitted On" value={submittedOn} />
            {showMovewareDetails && (
              <DetailField label="Moveware Details" value={`Job ID: ${movewareJobId(item) || "—"}`} />
            )}
            <DetailField label="Complete By Date">
              <Box display="flex" flexDirection="column" gap={0.75}>
                <Typography variant="body2">
                  {item.deadlineDate ? moment(item.deadlineDate, serverFormat).format("ll") : "-"}
                </Typography>
                <Box>
                  <OrderStatusChip vaStatus={item.vaStatus} orderType="internalWorkOrder" />
                </Box>
              </Box>
            </DetailField>
            {showBillingCharge && (
              <DetailField label="Billing Charge" value={formatBillingCharge(billingChargeTotal)} />
            )}
          </Box>
        </CardExpandable>
      </CardContent>
    </Card>
  );
}
